<template>
    <div class="page" v-if="authChecked">
        <div v-if="adminUser || bypass">
            <!-- <a class="square-btn" v-if="adminUser" @click="logout">Logout</a> -->
            <!-- <div class="logout" @click="logout">
                <svg alt="logout" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/></svg>
            </div> -->

            <slot />

        </div>
        <div v-else>
            <div class="login" @click.exact="googleLogin" @click.shift="showPasswordEntry = true">
                <code>Authenication with a @google.com email required</code>
                <img srcset="../assets/btn_google_signin_dark_normal_web@2x.png 2x">
            </div>

            <div v-show="showPasswordEntry">
                <input type="text" placeholder="password" @keyup.enter="passLogin" v-model="enteredPass">
            </div>
        </div>
    </div>
</template>


<script>
/* eslint-disable */

import firebase from 'firebase'
import db from '@shared/firebase/init'
console.log(db);

export default {
  data: () => ({
    currentUser: null,
    authChecked: false,
    showPasswordEntry: false,
    enteredPass: '',
    password: 'spectrum',
    bypass: false
  }),
  methods: {
    googleLogin() {			
			const provider = new firebase.auth.GoogleAuthProvider()
			firebase.auth().signInWithPopup(provider)
			.then((result) => {
				console.log(result);

			})
			.catch((err) => {
				console.log(err)
			})
    },
    passLogin() {
        if (this.enteredPass.toLowerCase().trim() == this.password.toLowerCase().trim()) {
            console.log('login');
            this.bypass = true
        } else {
            console.log('failed');
        }
    },
    logout() {
			firebase.auth().signOut().then(() => {
				// Sign-out successful.
				console.log('logged out');
				this.currentUser = null
			}).catch(function(error) {
			// An error happened.
			console.log(error);
			
			});
    },
  },
    computed: {
        adminUser () {
        return (this.currentUser && 
            (this.currentUser.email == 'adamplouff@gmail.com' || 
            this.currentUser.email.split('@')[1] == 'google.com')) 
            ? true : false
        }
    },

    created () {
		firebase.auth().onAuthStateChanged((firebaseUser) => {
			if (firebaseUser) {
				// store.dispatch('autoSignIn', firebaseUser)
				console.log(firebaseUser);
				this.currentUser = firebaseUser
				// this.refreshContent()
            }
            this.authChecked = true

            this.$store.state.firebase = firebase
        })
        // console.log('this.currentUser', this.currentUser);
        // console.log('db', db);
	},
}
</script>

<style scoped>
.login {
    margin: 20px;
    /* width: 100%; */
}
.login>* {
    text-align: center;
    display: block;
    /* margin-left: auto;
    margin-right: auto; */
    margin: 16px auto;
}

.logout {
    margin: 16px;
    position: absolute;
    right: 0;
    top: 0;
}
input {
    border: 1px solid var(--text-color);
    padding: 8px;
    text-transform: uppercase;
    display: block;
    margin: 0 auto;
}
</style>